import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col, Text } from 'shared/components'

import * as styles from './styles'

const UpdateButtonComponent = ({ onRouteToUpdateEditForm }) => (
  <Grid>
    <Row center="xs">
      <Col xs={12}>
        <Button
          circle
          small
          outlined
          onClick={onRouteToUpdateEditForm}
        >
          <FontAwesomeIcon size="lg" icon="pencil-alt" css={styles.icon} />
          <Text size={11}>Edit</Text>
        </Button>
      </Col>
    </Row>
  </Grid>
)

UpdateButtonComponent.propTypes = {
  onRouteToUpdateEditForm: PropTypes.func,
}

export default UpdateButtonComponent
